<template>
  <div class="car-owner-membership">
    <div class="tag">- 以下福利每30天可领取一次 -</div>
    <div class="welfare" v-for="(item, index) in list" :key="index">
      <div class="title">福利{{ index == 0 ? "一" : index == 1 ? "二" : "" }}</div>
      <div class="card">
        <div class="picture">
          <img :src="item.item_icon" />
        </div>
        <div class="cont">
          <div class="num">{{ item.item_price }}元{{ item.item_note }}</div>
          <div class="name">{{ item.item_name }}</div>
        </div>
        <div v-if="state(item.item_name)" class="btn prohibit">已领取</div>
        <div v-else class="btn" @click="handleEquityReceive(item)">立即领取</div>
      </div>
    </div>
    <div class="welfare">
      <div class="title">福利三<span class="annotation">打车券三选一</span></div>
      <ul class="list">
        <li
          :class="[
            'list-item',
            { active: carState.state && carState.name == item.item_name },
            { prohibit: carState.state && carState.name !== item.item_name },
          ]"
          v-for="(item, index) in list2"
          :key="index"
          @click="handleEquityReceive(item)"
        >
          <div class="picture">
            <img :src="item.item_icon" />
          </div>
          <div class="money">{{ item.item_price }}元</div>
          <div class="name">{{ item.item_name }}</div>
        </li>
      </ul>
    </div>
    <div class="tag2" @click="alert.visibility = true">使用说明</div>
    <v-alert
      :visibility.sync="alert.visibility"
      :title="alert.title"
      :message="alert.message"
    />
  </div>
</template>

<script>
import VAlert from "./dialog/alert.vue";
import { equityList, equityReceive } from "@/api/carOwner_zhengxing/receive.js";

import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    VAlert,
  },
  data() {
    return {
      alert: {
        visibility: false,
        title: "使用说明",
        message: `一、车主通用券:
1.本红包仅支持支付宝【出行-车生活】相关的加油、充电、高速MTC、停车场景，以及支付宝代驾小程序、支付宝租车小程序、支付宝洗车小程序、ETC服务小程序使用。
2.本红包在交易时支持叠加使用，最多叠加10个。本红包不可兑换现金，不可找零。
3.若使用红包的交易发生退款，红包将退回到原支付宝账号，使用有效期不变，退还红包在原有效期内可继续使用；如在原有效期外，则红包失效，不支持再次使用。
4.本红包仅限在中国大陆地区使用，限实名认证用户才可使用。
5.本券到账后有效期30天，过期作废，请及时使用。

二、滴滴代驾
1.代驾券仅限滴滴出行 APP 或微信客户端内代驾业务线上支付时使用(代驾券不可抵扣司机报单订单、路桥费、纯等候费)
2.代驾券仅限在滴滴出行-代驾业务开通的城市使用。
3.代金券充值自领取之日起有 30 天的有效，过期不退不换:滴滴订单时间需在券到账时间之后方可用，券到账前已经开始的订单无法使用
4.只能用于支付券码到帐滴滴钱包后发起的滴滴订单，在领取券码前已发起的订单无法支付

二、滴滴快车优惠券
1.本券仅支持账号绑定手机号码充值。请用户在充值前确保号码已开通滴滴账号。
2.本券为虚拟商品，一经提交充值不支持退换。
3.一笔订单只能使用一张优惠券，并且只能抵扣充值到账户之后的生成的订单，优惠券不拆分、不找零，请合理选择是否使用优惠券，优惠不足部分需用电子支付方式补足。拼车、特惠快车无法使用。
4.本券到账后有效期30天，过期作废，请及时使用。

三、滴滴专车优惠券
1.本券仅支持账号绑定手机号码充值。请用户在充值前确保号码已开通滴滴账号。
2.本券为虚拟商品，一经提交充值不支持退换。
3.一笔订单只能使用一张优惠券，并且只能抵扣充值到账户之后生成的订单，优惠券不拆分、不找零，请合理选择是否使用优惠券。
4.本券到账后有效期30天，过期作废，请及时使用。

四、高德打车优惠券
1.本券仅支持账号绑定手机号码充值，请用户在充值前确保号码已开通高德账号。
2.本券仅限在高德地图APP打车时使用，出租车、一口价订单不能使用。
3.同一订单优惠券最多可使用一张，不可叠加使用;券仅限一次性使用，不可拆分，不可转让，不可提现。
4.本券到账后有效期7天，过期作废，请及时使用。
`,
      },
      list2: [],
      list: [],
    };
  },
  computed: {
    ...mapGetters(["carOwner_zhengxing_token", "carOwner_zhengxing_user_info"]),
    state() {
      return (name) => {
        const data = this.carOwner_zhengxing_user_info.exchanged_items["车主会员"];
        return data && data.includes(name)  || false;
      };
    },
    carState() {
      const data = this.carOwner_zhengxing_user_info.exchanged_items["车主会员"] || [];

      let state = false;
      let name = "";

      for (const item of this.list2) {
        if (data.includes(item.item_name)) {
          state = true;
          name = item.item_name;
          break;
        }
      }
      return {
        state,
        name,
      };
    },
  },
  created() {
    this.getList();
    this["carOwner_zhengxing/getUserInfo"]();
  },
  methods: {
    ...mapActions(["carOwner_zhengxing/getUserInfo"]),
    async getList() {
      const res = await equityList({ item_require: "车主会员" });

      this.list2 = res.item.filter((coupon) =>
        /(滴滴专车|滴滴打车|高德)/.test(coupon.item_name)
      );
      console.log(this.list2);
      this.list = res.item.filter(
        (coupon) => !/(滴滴专车|滴滴打车|高德)/.test(coupon.item_name)
      );
    },
    async handleEquityReceive(row) {
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        mask: true,
        message: "加载中...",
      });
      const { item_name = "" } = row;
      const res = await equityReceive(this.carOwner_zhengxing_token, {
        item_name,
        item_require: "车主会员",
      });
      this.$toast.clear();
      if (res.code === 0) {
        this["carOwner_zhengxing/getUserInfo"]();
        this.$toast.success(res.message);
      } else {
        this.$toast.fail(res.message);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.car-owner-membership {
  //
  .tag {
    font-weight: 400;
    font-size: 28px;
    color: #dadada;
    line-height: 40px;
    text-align: center;
    padding: 36px 0 0;
  }

  .welfare {
    padding: 0 32px;

    .title {
      font-weight: 600;
      font-size: 30px;
      color: #333333;
      line-height: 42px;
      padding: 40px 0 30px;
    }

    .annotation {
      font-weight: 400;
      font-size: 26px;
      color: #999999;
      line-height: 37px;
      padding-left: 16px;
    }
    .card {
      height: 160px;
      background: #ffffff;
      box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.06);
      border-radius: 8px;
      display: flex;
      align-items: center;
      padding: 0 20px 0 20px;
      box-sizing: border-box;

      .picture {
        width: 126px;
        height: 126px;
        background: #f6f7fa;
        border-radius: 8px;
        text-align: center;
        margin-right: 30px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          height: 67px;
          width: 99px;
        }
      }

      .cont {
        font-weight: 400;
        flex: 1;

        .num {
          font-size: 32px;
          color: #333333;
          line-height: 45px;
          padding-bottom: 10px;
        }
        .name {
          font-size: 24px;
          color: #999999;
          line-height: 33px;
        }
      }
      .btn {
        width: 160px;
        height: 62px;
        text-align: center;
        line-height: 62px;
        background: rgba(220, 236, 255, 0.54);
        border-radius: 31px;
        border: 2px solid #4d9dff;
        font-weight: 400;
        font-size: 28px;
        color: #4d9dff;
        box-sizing: border-box;

        &.prohibit {
          background: rgba(0, 0, 0, 0.2);
          border-radius: 31px;
          border: 2px solid rgba(0, 0, 0, 0.1);
          color: #ffffff;
        }
      }
    }

    .list {
      display: flex;
      justify-content: space-between;
      &-item {
        width: 210px;
        height: 280px;
        background: #ffffff;
        box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.06);
        border-radius: 8px;
        text-align: center;
        padding-top: 17px;
        box-sizing: border-box;

        &.prohibit {
          opacity: 0.5;
        }

        &.active {
          position: relative;

          &::before {
            content: "";
            position: absolute;
            top: 0;
            bottom: 0;
            right: 0;
            left: 0;
            background: url("https://cdn.qiumo.net.cn/allsmarketmaterial/receive_zhengxing/ylq.png")
              center center/contain no-repeat;
          }
        }

        .picture {
          width: 176px;
          height: 126px;
          background: #f6f7fa;
          border-radius: 8px;
          display: flex;
          margin: 0 auto;
          justify-content: center;
          align-items: center;

          img {
            width: 99px;
            height: 67px;
          }
        }
        .money {
          font-weight: 400;
          font-size: 32px;
          color: #333333;
          line-height: 45px;
          padding: 24px 0 10px;
        }

        .name {
          font-weight: 400;
          font-size: 24px;
          color: #999999;
          line-height: 33px;
        }
      }
    }
  }
  .tag2 {
    font-weight: 400;
    font-size: 24px;
    color: #999999;
    line-height: 33px;
    padding-top: 40px;
    text-align: center;
  }
}
</style>
